export default __webpack_public_path__ + "static/media/mainscreenquiz.224db023.png";